import styled from "styled-components"

export const ParallaxedText = styled.p`
  color: ${({ color }) => (color ? color : "#fff")};
  white-space: nowrap;
  font-size: 170px;
  font-family: "sharp_grotesksemibold_25", sans-serif;
  padding-top: 170px;
  text-transform: uppercase;
  @media screen and (max-width: 992px) {
    font-size: 160px;
  }
  @media screen and (max-width: 767px) {
    font-size: 150px;
  }
  @media screen and (max-width: 576px) {
    font-size: 130px;
  }
`
